const root = '/';
const baseRoute = (path = '') => `${root}${path}`;

export default {
  root,
  install: baseRoute('docs'),
} as const;
